import { IAgreementListFilterRaw } from 'APIPackage/AgreementListModule/interfaces/IAgreementListFilterRaw';
import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { IAgreementListFilter } from 'AgreementListPackage/AgreementListFiltersModule/interfaces/IAgreementListFilter';
import { mapAgreementFilterToRaw } from 'AgreementListPackage/AgreementListFiltersModule/common/mapAgreementFilterToRaw';
import { initialAgreementListFilter } from 'AgreementListPackage/AgreementListFiltersModule/constants/initialAgreementListFilter';

export function getRawFilter(): IAgreementListFilterRaw {
  const current = getStorageItem<IAgreementListFilter>(StorageNamesEnum.AGREEMENT_LIST_FILTER);
  const isFilterOn = !!getStorageItem(StorageNamesEnum.AGREEMENT_LIST_FILTER_ON);
  const rawFilterData = mapAgreementFilterToRaw((isFilterOn && current) || initialAgreementListFilter);

  return {
    ...rawFilterData,
  };
}
